Ext.define('SA.view.ImportSuccessWindow', {
    alias: 'widget.import-success-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-import-success-window',
    includeOkBtn: true,
    title: 'Import Complete',

    getBodyItems() {
        if (this.isImportCountryCurrentCountry) {
            return {xtype: 'component', html: 'Your dataset has been successfully created.'};
        }

        return {
            xtype: 'component',
            data: this,

            tpl: [
                '<b>Your dataset has been successfully created.</b><br><br>',
                '<tpl if="importCountry === \'USA\'">',
                    'Please switch to a US project to view this data.',
                '<tpl else>',
                    'Please switch to a Canadian project to view this data.',
                '</tpl>'
            ]
        };
    }
});